'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _class, _temp, _class2, _temp2; // import SingleUploaderInput from '../../../../../react-cms-uploads/src/components/uploader/SingleUploader';
// import Button from 'material-ui/Button/Button';
// import Avatar from '../../../../../ui/Avatar';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _context = require('@prisma-cms/context');

var _context2 = _interopRequireDefault(_context);

var _SingleUploader = require('../../../../../../modules/react-cms-uploads/src/components/uploader/SingleUploader');

var _SingleUploader2 = _interopRequireDefault(_SingleUploader);

var _PersonOutline = require('material-ui-icons/PersonOutline');

var _PersonOutline2 = _interopRequireDefault(_PersonOutline);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var FileInput = (_temp = _class = function (_Component) {
  _inherits(FileInput, _Component);

  function FileInput() {
    _classCallCheck(this, FileInput);

    return _possibleConstructorReturn(this, (FileInput.__proto__ || Object.getPrototypeOf(FileInput)).apply(this, arguments));
  }

  _createClass(FileInput, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          user = _props.user,
          editable = _props.editable,
          other = _objectWithoutProperties(_props, ['user', 'editable']);

      var Avatar = this.context.Avatar;
      var image = user.image;
      var onClick = editable ? function (event) {
        var input = _this2.input;
        input.click();
      } : undefined;
      return _react2.default.createElement('div', null, image ? _react2.default.createElement(Avatar, {
        user: user,
        size: 'big',
        onClick: onClick,
        editable: editable
      }) : _react2.default.createElement(_PersonOutline2.default, {
        onClick: onClick,
        style: {
          fontSize: "7rem",
          color: "#ddd",
          border: "1px solid #ddd",
          borderRadius: "50%",
          cursor: "pointer"
        }
      }), _react2.default.createElement('input', _extends({
        type: 'file',
        ref: function ref(input) {
          _this2.input = input;
        },
        style: {
          display: "none"
        }
      }, other)));
    }
  }]);

  return FileInput;
}(_react.Component), _class.propTypes = {
  user: _propTypes2.default.object.isRequired
}, _class.contextType = _context2.default, _temp);
var UserProfileAvatar = (_temp2 = _class2 = function (_Component2) {
  _inherits(UserProfileAvatar, _Component2);

  function UserProfileAvatar(props) {
    _classCallCheck(this, UserProfileAvatar);

    var _this3 = _possibleConstructorReturn(this, (UserProfileAvatar.__proto__ || Object.getPrototypeOf(UserProfileAvatar)).call(this, props));

    _this3.state = {// file: null,
    };
    return _this3;
  }

  _createClass(UserProfileAvatar, [{
    key: 'onUpload',
    value: function onUpload(r) {
      var singleUpload = r.data.singleUpload;
      var updateUser = this.props.updateUser;
      updateUser(singleUpload); // this.setState({
      //   file: singleUpload,
      // });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var file = this.state.file;
      var _props2 = this.props,
          user = _props2.user,
          editable = _props2.editable;

      if (!user) {
        return null;
      } // const {
      //   photo,
      // } = user;


      return _react2.default.createElement('div', null, _react2.default.createElement(_SingleUploader2.default, {
        onUpload: function onUpload(result) {
          return _this4.onUpload(result);
        },
        FileInput: FileInput,
        editable: editable,
        user: user
      }));
    }
  }]);

  return UserProfileAvatar;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object.isRequired,
  updateUser: _propTypes2.default.func.isRequired,
  editable: _propTypes2.default.bool.isRequired
}, _temp2);
exports.default = UserProfileAvatar;
module.exports = exports['default'];